import appWrapperTypes from '../appWrapper/types';
import homepageTypes from '../homepage/types';

const initialState = {
  user: {
    isLoggedIn: false,
  },
  totalMembers: null,
  totalAmountFinanced: null,
  apartmentUnitsFinanced: 15000,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case appWrapperTypes.APP_INIT:
      return {
        ...state,
        user: {
          ...state.user,
          ...action.data.user,
        },
      };

    case appWrapperTypes.GET_USER_DATA_SUCCEEDED:
      return {
        ...state,
        user: action.user,
      };

    case homepageTypes.GET_TOKENS_SUCCEEDED:
      return {
        ...state,
        totalMembers: action.tokens.totalMembers,
        totalPropertyValueFinanced: action.tokens.totalPropertyValueFinanced,
      };

    default:
      return {
        ...state,
      };
  }
};
